import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { FormRestrictionStatus } from '@atlassian/proforma-form-security';

export type FetchProformaReqTypeFormDataParams = {
	cloudId: string;
	projectId: number;
	requestTypeId: number;
};

export type ProformaReqTypeFormDataResponse = {
	formId: number;
	formName: string;
	fields: {
		[fieldKey: string]: {
			key: string; // same as fieldKey, added by backend API as a placeholder,
			required?: boolean;
			conditional?: boolean;
		};
	};
	newIssueIssueTypeIds: number[];
	newIssueRequestTypeIds: number[];
	restrictionStatus?: FormRestrictionStatus;
};

export const fetchProformaReqTypeFormData = async ({
	cloudId,
	projectId,
	requestTypeId,
}: FetchProformaReqTypeFormDataParams): Promise<ProformaReqTypeFormDataResponse | null> =>
	performGetRequest(
		`/gateway/api/proforma/cloudid/${cloudId}/api/3/project/${projectId}/requesttype/${requestTypeId}/form/data`,
	);
